import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CampaignAnalyticsComponent } from './application/campaign-analytics/campaign-analytics.component';
import { ChannelImageViewerComponent } from './application/channel-image-viewer/channel-image-viewer.component';
import { ContactUsComponent } from './application/contact-us/contact-us.component';
import { DashboardComponent } from './application/dashboard/dashboard.component';
import { PrivacyPolicyComponent } from './application/privacy-policy/privacy-policy.component';
import { ScratchPadComponent } from './application/scratchpad/scratchpad.component';
import { TermsAndConditionComponent } from './application/terms-and-condition/terms-and-condition.component';
import { AuthGuard } from './core/authentication/auth.guard';
import { RoleSelectionComponent } from './role-selection/role-selection.component';
import { MainLayoutComponent } from './shared/main-layout/main-layout.component';

const routes: Routes = [
    {
        path: 'role-selection',
        component: RoleSelectionComponent
    },
    {
        // Opened in a new tab from Step 2 (list view); full-screen viewer, so outside MainLayoutComponent.
        path: 'channel-images/:channelId',
        component: ChannelImageViewerComponent,
        canActivate: [AuthGuard],
        data: { roles: ['client', 'supplier', 'admin'] }
    },
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'scratchpad',
                component: ScratchPadComponent,
                data: { roles: ['client', 'supplier', 'admin'] }
            },
            {
                path: 'dashboard',
                component: DashboardComponent,
                canActivate: [AuthGuard],
                data: { roles: ['client', 'supplier', 'admin'] }
            },
            {
                path: 'campaign/new',
                loadChildren: () =>
                    import('./application/new-campaign/new-campaign.module').then(
                        m => m.NewCampaignModule
                    ),
                canActivate: [AuthGuard],
                data: { roles: ['client', 'supplier', 'admin'] }
            },
            {
                path: 'campaign',
                loadChildren: () =>
                    import('./application/new-campaign/new-campaign.module').then(
                        m => m.NewCampaignModule
                    ),
                canActivate: [AuthGuard],
                data: { roles: ['client', 'supplier', 'admin'] }
            },
            {
                path: 'my-account',
                canActivate: [AuthGuard],
                data: { roles: ['client'] },
                loadChildren: () =>
                    import('./application/my-account/my-account.module').then(
                        m => m.MyAccountModule
                    )
            },
            {
                path: 'campaign-analytics',
                component: CampaignAnalyticsComponent,
                canActivate: [AuthGuard],
                data: { roles: ['client'] }
            },
            {
                path: 'contact-us',
                component: ContactUsComponent,
                data: { roles: ['client', 'supplier', 'admin'] }
            },
            {
                path: 'terms-and-conditions',
                component: TermsAndConditionComponent,
                data: { roles: ['client', 'supplier', 'admin'] }
            },
            {
                path: 'privacy-policy',
                component: PrivacyPolicyComponent,
                data: { roles: ['client', 'supplier', 'admin'] }
            }
        ]
    },
    {
        path: 'auth',
        loadChildren: () => import('./application/auth/auth.module').then(m => m.AuthModule)
    },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
